module.exports = __webpack_public_path__ + "img/698-e973a5.png";